module.exports = __webpack_public_path__ + "assets/img/feature-img1-fa26f4b8.jpg";